module.exports = __webpack_public_path__ + "static/og_tags-b2088aa101c10916e3ed1556937bf9d3.png";